import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store/rootReducer';
import { GetBudgetSpendByMonthQuery } from 'API';
// SEE-1232 row h: read from CDK. The superseded Amplify document stays in graphql/queries
// (SEE-1238 removes it).
import { cardService } from 'app/services/card.service';

export interface BudgetWidgetState {
  budget: number;
  spent: number;
  panelOpen: boolean;
}

export const initialState: BudgetWidgetState = {
  budget: 0,
  spent: 0,
  panelOpen: false,
};

export const getSpentBudget = createAsyncThunk('cards/budgetWidget/getSpentBudget', async (input: object) => {
  // Transport flip only — same `{ paidolId, yearAndMonth }` argument, same resolved amount.
  const record = await cardService.getBudgetSpendByMonth<GetBudgetSpendByMonthQuery['getBudgetSpendByMonth']>(
    input as { paidolId: string; yearAndMonth: string }
  );
  return record?.amount || 0;
});

const budgetWidgetSlice = createSlice({
  name: 'cards/budgetWidget',
  initialState,
  reducers: {
    resetBudgetWidgetSlice: () => {
      return initialState;
    },
    setPanelOpen: (state, action) => {
      state.panelOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSpentBudget.fulfilled, (state, action) => {
      state.spent = action.payload;
    });
  },
});

export const { resetBudgetWidgetSlice, setPanelOpen } = budgetWidgetSlice.actions;

export const selectBudgetWidgetSlice = (state: RootState): BudgetWidgetState =>
  state?.cards?.budgetWidget ?? initialState;

export default budgetWidgetSlice.reducer;
